<template>
  <div
    class="base-input"
    :class="{ error: hasValidationError }"
    :style="{ width }"
  >
    <label
      @click="() => !readonly && $refs.input.focus()"
      v-if="label"
      :class="['input__label', { readonly, disabled }]"
      >{{ label }}</label
    >

    <input
      :autocomplete="autocomplete ? 'on' : 'new-password'"
      ref="input"
      v-model="inputValue"
      @blur="handleBlur"
      @focus="$emit('focus')"
      :name="name"
      :placeholder="placeholder"
      :type="typeInput"
      class="input__field"
      :readonly="readonly"
      :disabled="disabled"
      @keydown="(evt) => $emit('keydown', evt)"
      @keyup="(evt) => $emit('keyup', evt)"
      @keypress="(evt) => $emit('keypress', evt)"
      :style="passwordStyle"
    />

    <svg @click="show = !show" class="icon eye-crossed-icon" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path v-if="!show" d="M17.6765 1.10742L3.32366 14.7217"
              stroke="currentColor" />
        <path
                d="M19.9998 7.65094C19.9998 7.65094 15.7976 12.8905 10.3845 12.9282C4.97144 12.9659 1 7.65094 1 7.65094C1 7.65094 5.02115 2.29831 10.3845 2.37371C15.7478 2.44913 19.9998 7.65094 19.9998 7.65094Z"
                stroke="currentColor" />
        <path
                d="M10.5004 4.48431C9.99803 4.48461 9.50296 4.6044 9.05606 4.83381C9.32875 4.90861 9.56933 5.07089 9.74082 5.29572C9.9123 5.52054 10.0052 5.79546 10.0053 6.07822C10.0053 6.24773 9.9719 6.41558 9.90704 6.57219C9.84218 6.7288 9.74712 6.8711 9.62725 6.99096C9.50739 7.11082 9.3651 7.20589 9.20849 7.27075C9.05188 7.33561 8.88402 7.36898 8.71451 7.36897C8.46005 7.36883 8.21133 7.29348 7.99957 7.15239C7.78782 7.0113 7.62249 6.81076 7.52437 6.57598C7.39908 6.92057 7.33457 7.28429 7.33374 7.65094C7.33376 8.49078 7.66738 9.29621 8.26124 9.89007C8.85509 10.4839 9.66053 10.8176 10.5004 10.8176C11.3402 10.8176 12.1456 10.4839 12.7395 9.89008C13.3334 9.29622 13.667 8.49078 13.667 7.65094C13.667 6.8111 13.3334 6.00567 12.7395 5.41181C12.1456 4.81795 11.3402 4.48433 10.5004 4.48431Z"
                fill="currentColor" />
    </svg>

    <slot v-if="hasValidationError && !serverValidationPending" />
  </div>
</template>

<script>
import Base from './Base/Base'

export default {
  name: 'vpassword',
  extends: Base,
  data () {
    return {
      show: false
    }
  },
  computed: {
    typeInput () {
      return !this.show ? 'password' : 'text'
    },
    passwordStyle () {
      return {
        fontSize: !this.inputValue.length ? 'font-size:18px' : null,
        paddingRight: '40px'
      }
    }
  },
  methods: {
    handleBlur () {
      this.$emit('blur')
      this.validate()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/system/_vars';
@import '@/assets/css/system/_mixins';

.icon {
  position: absolute;
  right: 10px;
  top: 46px;
  transition: 0.2s;
  cursor: pointer;
  color: $color_deactive;
  z-index: 21;

  &:hover {
    color: $font_color_main;
  }
}
.error {
  .icon {
    color: $color_error;
  }
}
  
</style>
